import React, { useContext } from 'react';
import { Form } from 'react-bootstrap';
import AppContext from './AppContext';

const CronJobEditor = ({ scheduleEnabled, scheduleDayOfWeek, scheduleWeekOccurrence, scheduleHour, scheduleMinute, scheduleRules, setScheduleData }) => {
  const appContext = useContext(AppContext);
  const { rulesList } = appContext;
  const rulesMap = getRulesMap(rulesList);

  const checked = Boolean(scheduleEnabled);
  const weekday = scheduleDayOfWeek || 'SAT';
  const weekdayOccurrence = scheduleWeekOccurrence || 1;
  const hour = scheduleHour != null ? scheduleHour : 0;
  const minute = scheduleMinute != null ? scheduleMinute : 0;
  const time = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
  const selectedRules = scheduleRules || rulesList.find(rules => rules.default === true) || rulesList[0];

  const emitChange = (overrides) => {
    const data = {
      scheduleEnabled: checked,
      scheduleDayOfWeek: weekday,
      scheduleWeekOccurrence: weekdayOccurrence,
      scheduleHour: hour,
      scheduleMinute: minute,
      scheduleRules: selectedRules,
      ...overrides
    };
    setScheduleData(data);
  };

  const checkHandler = (bool) => {
    emitChange({ scheduleEnabled: bool });
  };

  const changeWeekday = (value) => {
    if (checked) emitChange({ scheduleDayOfWeek: value });
  };

  const changeOccurrence = (value) => {
    if (checked) emitChange({ scheduleWeekOccurrence: parseInt(value, 10) });
  };

  const changeTime = (value) => {
    if (checked) {
      const parts = value.split(':');
      emitChange({
        scheduleHour: parseInt(parts[0], 10),
        scheduleMinute: parseInt(parts[1], 10)
      });
    }
  };

  const changeRules = (rulesId) => {
    emitChange({ scheduleRules: rulesList.find(r => r.id === rulesId) });
  };

  return (
    <div className='d-flex'>
      <div className='mt-2'>
        <Form.Check
          checked={checked}
          onChange={(e) => checkHandler(e.target.checked)}
          type='checkbox'
          id='schedule-checkbox'
          aria-label='schedule-automatic-scans'
        />
      </div>
      <div>
        <div style={{ color: checked ? '#212630' : '#8A92A0' }} className='cron-job-editor'>
          <div className='mr-2 mt-1 mb-1'>Run Discoveries on the </div>
          <Form.Control
            className='mr-1 mt-1 mb-1'
            disabled={!checked}
            onChange={(e) => changeOccurrence(e.target.value)}
            value={weekdayOccurrence}
            size='sm'
            as='select'
          >
            <option value='1'>First</option>
            <option value='2'>Second</option>
            <option value='3'>Third</option>
            <option value='4'>Fourth</option>
          </Form.Control>

          <Form.Control
            className='mr-1 mt-1 mb-1'
            disabled={!checked}
            onChange={(e) => changeWeekday(e.target.value)}
            value={weekday}
            size='sm'
            as='select'
          >
            <option value='SUN'>Sunday</option>
            <option value='MON'>Monday</option>
            <option value='TUE'>Tuesday</option>
            <option value='WED'>Wednesday</option>
            <option value='THU'>Thursday</option>
            <option value='FRI'>Friday</option>
            <option value='SAT'>Saturday</option>
          </Form.Control>

          <div className='mr-2 mt-1 mb-1'>of every month at</div>
          <Form.Control
            className='mr-1 mt-1'
            disabled={!checked}
            onChange={(e) => changeTime(e.target.value)}
            value={time}
            size='sm'
            type='time'
          />

          <div className='mr-2 mt-1 mb-1'>using Sampling Rules</div>
          <Form.Control
            className='mr-1 mt-1 mb-1'
            disabled={!checked}
            value={selectedRules.id}
            size='sm'
            as='select'
            onChange={(e) => changeRules(e.target.value)}
          >
            { rulesList.map((rules) => (
              <option key={rules.id} value={rules.id}>{rules.name}</option>
            ))}
          </Form.Control>
        </div>

        { rulesMap[selectedRules.id] && (
          <div className='mt-3 text-left' style={{ fontSize: '12px' }}>
            <span className='accent'>{selectedRules.name}</span>{' '}
            will sample <span className='accent'>{rulesMap[selectedRules.id].size}</span>{' '}
            rows every <span className='accent'>{rulesMap[selectedRules.id].every}</span> rows.
          </div>
        )}
      </div>
    </div>
  )
};

function getRulesMap(rulesList) {
  const rulesMapValue = {};
  rulesList.forEach((rules) => {
    const id = rules.id;
    const row = rules.sample && rules.sample.row;
    if (row) rulesMapValue[id] = row;
  });
  return rulesMapValue;
}

export default CronJobEditor;
